import { VApp } from 'vuetify/lib/components/VApp';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VApp, [_c(VForm, {
    ref: "form",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c(VContainer, {
    staticClass: "fill-height",
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticClass: "fill-height mx-0",
    style: _vm.getBG(),
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c(VCol, {
    staticClass: "text-center px-0 n20-login-card-wrapper"
  }, [_c('material-card', {
    staticClass: "v-card-profile n20-login-card n20-login-card-dimensions"
  }, [_vm.loginLogo.orientation === 'portrait' ? _c('div', {
    staticClass: "mx-auto d-flex align-center justify-center mb-4"
  }, [_c(VAvatar, {
    staticClass: "ma-0 mt-2",
    attrs: {
      "tile": "",
      "size": "110"
    }
  }, [_c(VImg, {
    attrs: {
      "src": _vm.loginLogo.image,
      "width": "110",
      "contain": ""
    }
  })], 1)], 1) : _vm._e(), _vm.loginLogo.orientation !== 'portrait' ? _c(VImg, {
    staticClass: "px-6 mt-4 mx-auto n20-login-logo-ls",
    attrs: {
      "src": _vm.loginLogo.image,
      "contain": ""
    }
  }) : _vm._e(), _c('p', {
    staticClass: "ml-0 mr-0 mt-6 mb-4 text-h6"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('accMgmt.oauth.headline')) + "\n            ")]), _c(VCardText, {
    staticClass: "text-center pt-0"
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('accMgmt.oauth.allowInfoText')) + "\n                  ")]), _c(VCol, {
    staticClass: "login-button-center",
    attrs: {
      "cols": "12"
    }
  }, [_c(VBtn, {
    staticClass: "v-btn-x",
    attrs: {
      "color": _vm.$store.state.app.color,
      "loading": _vm.loading,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.redirectFn();
      }
    }
  }, [_c(VIcon, {
    staticClass: "mr-3",
    attrs: {
      "left": ""
    }
  }, [_vm._v("fal fa-sign-in-alt")]), _vm._v("\n                    " + _vm._s(_vm.$i18n_t('accMgmt.oauth.allow')) + "\n                  ")], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };